import {CSS} from '@stitches/react';

export const listCSS: CSS = {
	'& li': {
		minHeight: 40,
	},

	'& li:not(:last-child)': {
		marginBottom: 6,
	},
};
